import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PdfService } from '@core/services/pdf.service';
import { combineLatest, EMPTY, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ConteudoService } from '@core/services/conteudo.service';
import { MatPageable } from '@core/table/mat-table';

interface UpdateEntry {
  id: string;
  title: string;
  description: string;
  date: string;
  imgPath: string;
}

@Component({
  selector: 'app-cnseg-updates',
  templateUrl: './cnseg-updates.component.html',
  styleUrls: ['./cnseg-updates.component.scss']
})
export class CnsegUpdatesComponent implements OnInit, OnDestroy {

  updateTemplates: UpdateEntry[] = [];
  currentUpdate: UpdateEntry | null = null;
  currentHtml: SafeHtml | null = null;

  idNovidade: string;
  novidades: any[] = [];
  novidade: any;

  private destroy$ = new Subject<void>();

  constructor(
    private _pdfService: PdfService,
    private _activatedRoute: ActivatedRoute,
    private _http: HttpClient,
    private _sanitizer: DomSanitizer,
    private _conteudoService: ConteudoService
  ) { }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe(value => this.idNovidade = value.id);

    if (this.idNovidade) {
      this._conteudoService.buscarNovidadesPorId(this.idNovidade).subscribe(novidade => {
        this.currentHtml = this._sanitizer.bypassSecurityTrustHtml(novidade.txtConteudoHtml);
        this.novidade = {
          ...novidade,
          categorias: [...(novidade.categorias || [])].sort((a, b) =>
            a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' })
          )
        };
      })
    } else {
      const paginacao = new MatPageable(1, 9999);
      this._conteudoService.buscarTodasNovidades(paginacao)
        .pipe(
          switchMap(novidades => this._conteudoService.buscarConteudosComImagens(novidades || []))
        )
        .subscribe(novidades => this.novidades = novidades);
    }


  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exportPDF(): void {
    this._pdfService.beforeCanvas('updateContainer');
    window.onafterprint = () => {
      this._pdfService.afterCanvas('updateContainer');
    };
    window.print();
  }

}
